export const DeliveryToTheOffice = 1;
export const DeliveryToMoscow = 2;
export const DeliveryToOtherRegion = 3;

export default {
    DeliveryToTheOffice, DeliveryToMoscow, DeliveryToOtherRegion
}